import { FC } from "react"
import Icon from "@material-ui/core/Icon"

import { ISteps } from "./interfaces"

const Steps: FC<ISteps> = ({
  description,
  completed,
  selected,
  active,
  number
}) => {
  const btnClass = [
    "step-item",
    active ? "item-active" : "",
    completed ? "item-completed" : "",
    selected ? "item-selected" : ""
  ]

  const btnClassname = btnClass.join(" ")

  return (
    <>
      <li className={btnClassname}>
        <div className="step-number-container">
          <span className="step-number-bg" />
          <span className="step-number">
            {" "}
            {completed ? (
              <Icon className="ocs-md-btn-icon">done</Icon>
            ) : (
              number
            )}{" "}
            {/* {number} */}
          </span>
        </div>

        {description && (
          <div
            className={`${description !== "" ? "description" : "descriptions"}`}
          >
            {description}
          </div>
        )}
      </li>
    </>
  )
}

export default Steps
